module.exports = __webpack_public_path__ + "static/communication-service.13e13a72.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/Page/img/communication-service.png
// module id = 788
// module chunks = 28686525722576